import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ForgotPassword from './features/auth/components/ForgotPassword';
import ResetPassword from './features/auth/components/ResetPassword';
import HomePage from './pages/HomePage';
import CadastroRestaurante from './pages/CadastroRestPage';
import GestUsersPage from './pages/GestUsersPage';
import MenusPage from './pages/MenusPage';
import InitialPage from "./pages/InitialPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import SalaoPage from './pages/SalaoPage';
import RelatoriosPage from './pages/RelatoriosPage';
import CozinhaPage from './pages/CozinhaPage';
import UpgradePage from './pages/UpgradePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import DeliveryPage from './pages/DeliveryPage';
import ConfigPrinterPage from './pages/ConfigPrinterPage';
import ProtectedRoute from "./components/ProtectedRoute";
import { ThemeProvider } from "./context/ThemeContext";


function App() {

  return (
    <ThemeProvider>

      <Router>
        <Routes>
          <Route path="/" element={<InitialPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/assinatura/upgrade" element={<UpgradePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />


          <Route path="/home" element={<ProtectedRoute> <HomePage /> </ProtectedRoute>} />
          <Route path="/restaurantes" element={<ProtectedRoute> <CadastroRestaurante /> </ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute> <GestUsersPage /> </ProtectedRoute>} />
          <Route path="/menus" element={<ProtectedRoute> <MenusPage /> </ProtectedRoute>} />
          <Route path="/salao" element={<ProtectedRoute>  <SalaoPage /> </ProtectedRoute>} />
          <Route path="/relatorios" element={<ProtectedRoute> <RelatoriosPage /> </ProtectedRoute>} />
          <Route path="/cozinha" element={<ProtectedRoute> <CozinhaPage /> </ProtectedRoute>} />
          <Route path="/delivery" element={<ProtectedRoute> <DeliveryPage />  </ProtectedRoute>} />
          <Route path="/configs" element={<ProtectedRoute> <ConfigPrinterPage /> </ProtectedRoute>} />

        </Routes>
      </Router>
    </ThemeProvider>

  );
}

export default App;
